import axiosPrivateMl from "./axiosPrivateMl"

const getSheetValidation = async (payload) => {
  const response = await axiosPrivateMl.post(
    "/sheet_validate_and_process",
    payload
  )
  return response.data
}

export default getSheetValidation
